module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAMBAMAAABCcoqQAAAALVBMVEUAAAD3w1X4w1X3wlX4w1X4w1X4w1X6xVb6w1j5xVn/zFz/1VX4w1X3w1b4wlVFCs9MAAAADnRSTlMAxrrmr5lmNi4pGQbVqS5PJrgAAAAvSURBVAjXY2i6zgAE594lAMl3755uAJHvpMDk4wkg8p0DhESISMFUyoF1NakDCQAcnyKfuZxGLgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base/right_to.png
// module id = kY/B
// module chunks = 0